const BlogData= [
    {id:1,
     img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/62068f4558afd109e9852e86_twelve-p-500.png",
     detail:"The 12 Best Social Media Management Tools According To Lately",
   
 },
 {id:2,
     img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/61e877dc5918544d73ea3592_004-p-500.png",
     detail:"Repurpose Your Live Streams to Double Up on Engagement - Christian Karasiewicz of Launch Your Live Podcast Interviews Kately from Lately.AI",
  
 },
 {id:3,
     img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/61e8780d78706be96a64ceba_001-p-500.png",
     detail:"Natasha Miller of Fascinating Entrepreneurs Featuring Lately CEO Kate Bradley Chernis Lately: The Future of Social Selling - How Lately Changed Social Selling Forever",
   
 },
 {id:4,
     img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/61e8782a99be3bc23a797054_003-p-500.png",
     detail:"Tying the Pieces of Life Together, with Carol Clegg of Connect, Inspire, Create: Conversations for Women Entrepreneurs - Featuring Lately CEO Kate Bradley Chernis",
  
 },
 {id:5,
     img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/620c005450ca932e37f4f331_fab-p-500.png",
     detail:"How to Build Evangelists From The Inside Out - Fab Calando and Paul Lafleur of Ask the Right Questions Podcast Interview Kate Bradley Chernis",
    
 },
 {id:6,
     img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/619cfa3d2373ded40e43629e_music-p-500.png",
     detail:"14 Must Listen-to Podcasts That’ll Knock the Earbuds Out of Your Ears",

 },
 {id:7,
     img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/618157da4e90d734b0fcd742_ann-p-500.png",
     detail:" How To Use Artificial Intelligence To Skyrocket the Effectiveness of Your Social Media Calendar - Ann Smarty of Viral Content Bee Interviews Kately from Lately.AI",
     
 },
 {id:8,
     img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/6169a03a74b988ec23b22838_writingtorobots-p-500.png",
     detail:"Can A.I. Replace Human Writers?",
  
 },
 {id:9,
    img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/6165d9b29267297913c33055_bttf2-p-500.png",
    detail:" Modernize the Way You Market! HubSpot + INBOUND = MAGIC",
    
},
{id:10,
    img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/613ba25e934830151c4fe42d_hubspotbond-p-500.png",
    detail:" Supercharge Your Content with Lately & HubSpot",
    
},
{id:11,
    img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/613a518010abb119dc42753c_blogpost-p-500.png",
    detail:"A.I. Makes Social Selling a Breeze",
    
},
{id:12,
    img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/610d460573819ac6412ebb5e_lauren-p-500.png",
    detail:"Turn Customers into FANS: The Keys to Customer Success",
    
},

 
 
 
 ]
 export default BlogData